/*
 * @FilePath     : /es-package/packages/es-mpx-usex/login/login.web.js
 * @Author       : LiYang
 * @Date         : 2021-08-27 16:29:37
 * @LastEditTime: 2024-01-15 13:03:23
 * @LastEditors: zhuyating zhuyating@didichuxing.com
 * @Description  : h5登录
 */
import { mpx } from '@didi/es-mpx-creator'
import { toPromise } from '@didi/es-mpx-shared'
import { setStorage } from '@/utils/storage'
import {
  isLogin,
  login,
  query,
  hashQuery,
  canIUse,
  setLoginConfig
} from '@didi/webx-js'
import { AES_ECB_ENCRYPT } from '@/common/crypto'
/**
 * 链接参数
 * @returns
 */
 export const myQuery = () => {
  return { ...query() , ...hashQuery()}
}
/**
 * 登陆
 * @param {*} needLogin
 */
 export const initLogin = async needLogin => {
  const queryParams = myQuery()
  const token = queryParams.token || queryParams.ticket
  return new Promise((resolve, reject) => {
    if (!needLogin){
      if (token && token !== '__token__') {
        resolve({ token })
        return
      }
    }
    canIUse('setLoginConfig') && setLoginConfig({
      loginType: 'trinity',
      productType: 'didi',
      offline: false,
    })
    isLogin({ useQuick: !needLogin })
      .then(res => {
        console.log('当前处于登陆状态')
        res.phone = AES_ECB_ENCRYPT(res?.phone)
        resolve(res)
      })
      .catch(error => {
        //未登陆
        console.log(error, 'isLogin error')
        if (needLogin) {
          //此处处理一下url
          const loginConfig = queryParams.appid === '121735'
            ? { fail_url: encodeURIComponent(window.location.href) }
            : {}
          login(loginConfig)
          // login()
            .then(res => {
              //token	string	用户登录秘钥
              // phone	string	用户手机号
              // uid	number	滴滴用户id
              console.log("登陆成功")
              res.phone = AES_ECB_ENCRYPT(res?.phone)
              resolve(res)
            })
            .catch(error => {
              console.log(error, 'login error111111')
              mpx.removeStorageSync('token')
              mpx.removeStorageSync('userInfo')
              reject(error)
            })
        } else {
          console.log('非强制登陆清除')
          mpx.removeStorageSync('token')
          mpx.removeStorageSync('userInfo')
          resolve()
        }
      })
  })
}

export const logout = () =>
  toPromise((success) => {
    ;['token', 'userInfo', 'phone','uid'].forEach(mpx.removeStorageSync)
    success()
  })
